import { CellProps } from 'react-table';

import { TrackableList } from 'types/trackables';

import { useModal } from 'hooks/useModal';
import { useDeleteTrackableLists } from '../../hooks/useDeleteTrackableLists';

import {
  ContextMenu,
  ContextMenuAction,
} from 'components/ContextMenu/ContextMenu';
import { IconButton } from 'components/IconButton/IconButtonDeprecated';

export type TrackableListsTableActionsCellProps = CellProps<TrackableList> & {
  onEdit?: (trackableList: TrackableList) => void;
};

export function TrackableListsTableActionsCell({
  row,
  onEdit,
}: TrackableListsTableActionsCellProps) {
  const trackableList = row.original;

  const { open } = useModal();
  const { mutateAsync: deleteTrackableLists } = useDeleteTrackableLists();

  function handleEditClick() {
    onEdit?.(trackableList);
  }

  function handleDeleteClick() {
    open('confirm-delete', {
      title: `Are you sure you want to delete ${trackableList.name}?`,
      onConfirm: () =>
        deleteTrackableLists({
          trackable_list_ids: [trackableList.id],
        }),
    });
  }

  return (
    <ContextMenu
      trigger={
        <IconButton
          icon="more-vertical"
          label="Reveal more actions"
          variant="ghost"
        />
      }
    >
      {onEdit && (
        <ContextMenuAction onClick={handleEditClick} icon="edit">
          Edit
        </ContextMenuAction>
      )}
      <ContextMenuAction onClick={handleDeleteClick} icon="delete">
        Delete
      </ContextMenuAction>
    </ContextMenu>
  );
}
